module.exports = __webpack_public_path__ + "404.html";


//////////////////
// WEBPACK FOOTER
// ./src/static/404.html.static
// module id = 14
// module chunks = 0